/**
 * axios setup to use mock service
 */

import axios from 'axios';
import { API_END_POINT } from 'config';

const TOKEN_KEY = "token";

// ---- Global defaults (affects all axios imports) ----
axios.defaults.baseURL = API_END_POINT;
axios.defaults.withCredentials = true;
// lock to your API host unless you explicitly override per request
axios.defaults.allowAbsoluteUrls = false;

//const axiosServices = axios.create({
    // baseURL: 'http://localhost:8080/api/auth'
    //baseURL: API_END_POINT
//});
const getToken = () =>
  sessionStorage.getItem(TOKEN_KEY) ?? localStorage.getItem(TOKEN_KEY);

/*const getToken = () => {
    const sessionToken = sessionStorage.getItem("token");
    if (sessionToken) {
        localStorage.removeItem("token");
        return sessionToken;
    }
    return localStorage.getItem("token");

}*/
axios.interceptors.request.use(
    (config) => {
        const token = getToken();
        config.headers = config.headers ?? {};
        if (token) config.headers.Authorization = `Bearer ${token}`;
        else delete config.headers.Authorization; // avoid "Bearer null"
        return config;
        //config.headers.Authorization = `Bearer ${getToken()}`;
        //return config;
    },
    (error) =>
        // Do something with request error
        Promise.reject(error)
);

// interceptor for http
axios.interceptors.response.use(
    (response) => response,
    (error) => {
        const status = error?.response?.status;
        const msg =
          error?.response?.data?.message ||
          error?.response?.data?.error ||
          "";
        console.log("status");
        if (status === 401 || /Unauthenticated\.|sid|concurrent/i.test(msg)) {
            sessionStorage.removeItem(TOKEN_KEY);
            localStorage.removeItem(TOKEN_KEY);
            window.location.href = "/login";
            return Promise.reject(error);
          }
            // network/CORS: err.response is undefined
        return Promise.reject(error);
    }
);

export default axios;
